export class Dieta {

    id?: number;
    descrizione?: string;
    idDieta?: number;

    constructor(data: any) {
        Object.assign(this, data);
    }

    get viewValue(): string {
        return this.descrizione ? this.descrizione : '';
    }

    get value(): Dieta {
        return this;
    }

}


